import './explore-category.component.scss'
import { matchMedium, breakpoints } from '../../application/utils/breakpoints'

import { Swiper, Keyboard, Mousewheel } from 'swiper'
Swiper.use(Keyboard)
Swiper.use(Mousewheel)

function createSwiper(swiperElement) {
  new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 8,
    slidesOffsetAfter: -80,
    mousewheel: {
      forceToAxis: true
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    breakpoints: {
      [breakpoints.small + 1]: {
        slidesPerView: 3,
        slidesOffsetAfter: 0
      },
      [breakpoints.smallest + 120]: {
        slidesPerView: 2,
        slidesOffsetAfter: -80
      }
    }
  })
}

function destroySwiper(swiperElement) {
  if (swiperElement.swiper) {
    swiperElement.swiper.destroy(true, true)
    setTimeout(() => {
      swiperElement
        .querySelectorAll('.swiper-slide')
        .forEach((slide) => (slide.style = ''))
    })
  }
}

const matchInstance = matchMedium()

const swiperElements = []
document.querySelectorAll('.explore-category').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  if (swiperElement) {
    swiperElements.push(swiperElement)
  }
})

function toggleState(matches) {
  if (matches) {
    swiperElements.forEach(createSwiper)
  } else {
    swiperElements.forEach(destroySwiper)
  }
}

if (swiperElements.length > 0) {
  toggleState(matchInstance.matches)
  matchInstance.subcribe(toggleState)
}
